<template>
  <div id="Card">
    
    <section class="widget rainbow" :class="StyleProp?StyleProp:''">
      <b-spinner class="float-left" v-if="loading"></b-spinner>
      <a v-b-toggle="Name" class="float-left m-1" v-if="collapse"><i class="fad fa-sort-alt h5"></i></a>
      <b-dropdown v-if="tools" size="md" variant="link" class="d-inline float-left" toggle-class="text-decoration-none " no-caret>
        <template #button-content
          ><h4><i class="fad fa-gear text-secondary"></i></h4>
        </template>
        <b-dropdown-item href="#" v-if="toolsList">تنظیمات</b-dropdown-item>
        <b-dropdown-item href="#" v-if="toolsColumns" @click="AlignColumns()">چیدمان ستون</b-dropdown-item>
      </b-dropdown>
      <a v-if="edit" class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="EditData()" data-title="اصلاح ردیف">
        <h5><i class="fas fa-marker text-success" style="color:var(--sidebar-color-item) !important"></i></h5>
      </a>
      <router-link v-if="$route.name == 'CustomerManager'" :to="{ name: 'AddCustomer' }" class="d-inline float-left mx-2 mt-1" data-title="مشتری جدید">
        <h4>
          <i v-if="$route.name == 'CustomerManager'" class="fad fa-user-plus" style="color:var(sidebar-color-item) !important"></i>
        </h4>
      </router-link>

      <a v-if="add" class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="AddRow()" data-title="ردیف جدید">
        <h4>
          <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
        </h4>
      </a>
      <a v-if="back" class="d-inline float-right ml-3 mt-1" href="javascript:;" @click="backed()">
        <h5><i class="fad fa-arrow-right text-secondary"></i></h5>
      </a>
      <slot name="btnCustome" class="d-inline float-left mx-2 mt-1"></slot>
      <slot name="header"> </slot>
      <div v-if="collapse">
        <b-collapse  :id="Name+''">
        <slot name="content"> </slot>
      </b-collapse>
      </div>
      <div v-else>
        <slot name="content"> </slot>
      </div>
      
      <slot name="footer"> </slot>
    </section>
    <ModalGridColumns v-if="toolsColumns"></ModalGridColumns>
  </div>
</template>
<script>
import ModalGridColumns from '@/pages/Public/ModalGridColumns.vue'
export default {
  data() {
    return {}
  },
  props: {
    add: { type: Boolean, default: false },
    back: { type: Boolean, default: false },
    tools: { type: Boolean, default: false },
    toolsList: { type: Boolean, default: false },
    toolsColumns: { type: Boolean, default: false },
    edit: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    collapse: { type: Boolean, default: false },
    Name: { type: String, default: 'Id' },
    StyleProp: { type: String, default: '' },
  },
  methods: {
    AlignColumns() {
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
        this.$bvModal.show('modal-scopedAlignColumns')
      })
    },
    AddRow() {
      this.$router.push({
        name: 'Detail' + this.$route.name,
        params: { Status: 'Add' },
      })
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    EditData() {
      this.$router.push({
        name: 'Detail' + this.$route.name,
        params: { Status: 'Edit' },
      })
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    backed() {
      if (this.$route.name != 'CustomerSms') {
        this.$router.go(-1)
      } else {
        // console.log()
        this.$FindeCustomerById('DetailCustomer',this.$store.state.CustomerId,false,null)
        // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: this.$store.state.CustomerId } })
      }
    },
  },
  components: { ModalGridColumns },
}
</script>
<style scoped>
.widget {
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
}
table {
  background: var(--sidebar-color-item);
}
th {
  color: #fff;
}
</style>
